import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home'
import about from '../pages/about'
import services_pms from '../pages/services_pms'
import services_pos from '../pages/services_pos'
import services_weixin from '../pages/services_weixin'
import services_sale from '../pages/services_sale'
import services_custom from '../pages/services_custom'
import services_zzj from '../pages/services_zzj'
import download from '../pages/download'
import news_list from '../pages/news_list'
import news from '../pages/news'
import content from '../pages/content'
import project from '../pages/project'

Vue.use(Router)

export default new Router({
  //mode:'history',
  scrollBehavior(to,from,saveTop){
    if(saveTop){
      return saveTop;
    }else{
      return {x:0,y:0}
    }
  },
  routes: [
    {
      path: '/',
      component: home,
      
    },    
    {
      path: '/home',
      name:'home',
      component: home,
      
    },
    {
      path:'/about',
      name:'about',
      component:about
    },          
    {
      path:'/services_pms',
      name:'services_pms',
      component:services_pms
    },             
    {
      path:'/services_pos',
      name:'services_pos',
      component:services_pos
    },               
    {
      path:'/services_weixin',
      name:'services_weixin',
      component:services_weixin
    },             
    {
      path:'/services_sale',
      name:'services_sale',
      component:services_sale
    },             
    {
      path:'/services_custom',
      name:'services_custom',
      component:services_custom
    },             
    {
      path:'/services_zzj',
      name:'services_zzj',
      component:services_zzj
    },  
    {
      path:'/download',
      name:'download',
      component:download
    },   
    {
      path:'/project',
      name:'project',
      component:project
    },        
    {
      path:'/news_list',
      name:'news_list',
      component:news_list
    },          
    {
      path:'/news_list/news',
      name:'news',
      component:news
    },      
    {
      path:'/content',
      name:'content',
      component:content
    }, 
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js